<template>
  <Modal
    v-model="localAddPointVisible"
    :title="localOperationsType == 6 ? '屏蔽' : '解除屏蔽'"
    @on-ok="ok"
    @on-cancel="cancel"
    class-name="point-shielding-modal"
    width="1000px"
    :footer-hide="true"
  >
    <div class="point-shielding-box">
      <div class="point-shielding-serch">
        <Form
          ref="addPointFormCustom"
          :model="addPointFormCustom"
          :rules="addPointRuleCustom"
          inline
          :label-width="100"
        >
          <Row>
            <Col span="6">
              <FormItem label="回路号" prop="circuitNo">
                <Input
                  type="text"
                  v-model="addPointFormCustom.circuitNo"
                  placeholder="请输入回路号"
                ></Input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="回路地址号" prop="addressNo">
                <Input
                  type="text"
                  v-model="addPointFormCustom.addressNo"
                  placeholder="请输入回路地址号"
                ></Input> </FormItem
            ></Col>
            <Col span="6">
              <FormItem label="设备类型" prop="deviceType">
                <Select
                  clearable
                  v-model="addPointFormCustom.deviceType"
                  placeholder="请选择设备类型"
                >
                  <Option
                    v-for="(item, index) in deviceTypeCode"
                    :value="item.value"
                    :key="index"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem></Col
            >
            <Col span="3">
              <Button
                type="primary"
                @click="handleReset('addPointFormCustom')"
                style="margin-left: 8px"
                >搜索</Button
              >
            </Col>
          </Row>
        </Form>
      </div>
      <div class="point-shielding-right">
        <Table
          border
          ref="selection"
          :columns="columns4"
          :data="pointTableList"
        >
          <!-- <template :slot-scope="{ row, index }" slot="action">
            <Poptip
              confirm
              :title="
                '请确认是否' + localOperationsType == 6
                  ? '屏蔽'
                  : '解除屏蔽' + '？'
              "
              @on-ok="listOperation(params.row, localOperationsType)"
            >
              <a style="color: red">{{
                localOperationsType == 6 ? "屏蔽 " : "解除屏蔽"
              }}</a>
            </Poptip>
          </template> -->
        </Table>
        <div class="point-shielding-page">
          <Page
            :total="pages.totalCount"
            :current="pages.currentPage"
            :page-size="pages.pageSize"
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
            show-sizer
            show-elevator
            show-total
          ></Page>
        </div>
      </div>
    </div>
    <!-- <div slot="footer">
      <Button @click="cancel">关闭</Button>
    </div> -->
  </Modal>
</template>

<script>
import Cookies from "js-cookie";
export default {
  props: {
    pointShieldingVisible: Boolean,
    operationsType: Number, //6屏蔽 7解除屏蔽
    orgId: String | Number,
    moduleId: String | Number,
    controllerNum: String | Number,
  },
  data() {
    return {
      localAddPointVisible: this.pointShieldingVisible, // 使用本地数据属性
      localOperationsType: this.operationsType,
      deviceTypeCode: [],
      addPointFormCustom: {
        circuitNo: "",
        addressNo: "",
        deviceType: "",
      },
      addPointRuleCustom: {
        circuitNo: [{ required: false, message: "回路号", trigger: "blur" }],
        addressNo: [
          { required: false, message: "回路地址号", trigger: "blur" },
        ],
        deviceType: [{ required: false, message: "设备类型", trigger: "blur" }],
      },
      pages: {
        totalCount: 0,
        pageSize: 10,
        currentPage: 1,
      },
      columns4: [
        {
          title: "点位名称",
          key: "name",
        },
        {
          title: "点位类型",
          key: "typeName",
        },
        {
          title: "回路号",
          key: "circuitNum",
        },
        {
          title: "回路地址号",
          key: "bitNum",
        },
        {
          title: "操作",
          key: "action",
          slot: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            let txt = this.localOperationsType == 6 ? "屏蔽 " : "解除屏蔽";
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#FF0C0C",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `操作`,
                        content: `<p>确认${
                          this.localOperationsType == 6 ? "屏蔽" : "解除屏蔽"
                        }？</p>`,
                        onOk: () => {
                          this.listOperation(
                            params.row,
                            this.localOperationsType
                          ).then((res) => {
                            if (res.data.success) {
                              this.$Message.success(res.data.data.message);
                              this.getTabList();
                              this.$emit("upDateRefresh", {});
                            } else {
                              this.$Message.console.error(
                                res.data.data.message
                              );
                            }
                            // resolve();
                          });
                        },
                        onCancel: () => {
                          reject();
                        },
                      });
                    },
                  },
                },
                txt
              ),
            ]);
          },
        },
      ],
      pointTableList: [],
    };
  },
  watch: {
    operationsType(newValue) {
      this.localOperationsType = newValue; // 监听prop的变化并更新本地数据属性
    },
    pointShieldingVisible(newValue) {
      this.localAddPointVisible = newValue; // 监听prop的变化并更新本地数据属性
      if (newValue) {
        setTimeout(() => {
          this.getTabList();
        }, 1000);
      }
    },
  },
  methods: {
    ok() {
      this.$emit("pointShieldingUpdate", { aa: "111" });
      this.localAddPointVisible = false; // 修改本地数据属性
    },
    cancel() {
      this.$emit("pointShieldingUpdate");
      this.localAddPointVisible = false; // 修改本地数据属性
    },
    async getTabList() {
      try {
        let params = {
          orgId: this.orgId,
          mainframeId: this.moduleId,
          circuitNum: this.addPointFormCustom.circuitNo,
          bitNum: this.addPointFormCustom.addressNo,
          partTypeCode: this.addPointFormCustom.deviceType,
          currentPage: this.pages.currentPage,
          pageSize: this.pages.pageSize,
        };
        if (this.localOperationsType == 6) {
          params.noWorkState = "shield";
        } else {
          params.workState = "shield";
        }
        const response = await this.$Axios({
          url: `/mcbw/host_parts`,
          type: "get",
          obj: params,
        });
        if (response.data.success) {
          this.pointTableList = response.data.data;
          this.pages.totalCount = response.data.totalCount;
        }
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    handleReset(name) {
      //   this.$refs[name].resetFields();
      this.$refs[name].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.getTabList();
        }
      });
    },
    // 列表操作
    async listOperation(activeItem, type) {
      try {
        let params = {
          targetType: 1,
          tid:
            this.controllerNum +
            "-" +
            activeItem.circuitNum +
            "-" +
            activeItem.bitNum +
            "-" +
            activeItem.partTypeCode,
          operate: 0,
          value: type == 6 ? 1 : 0,
          hostId: this.moduleId,
          downValue:
            Cookies.get("userName") +
            "执行" +
            activeItem.name +
            (type == 6 ? "屏蔽" : "解除屏蔽") +
            "操作。",
        };
        const response = await this.$Axios({
          url: `/mcbw/fire_control_hosts/control`,
          type: "post",
          obj: params,
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 获取设备类型下拉选项
    async getDeviceTypeCodeOption() {
      try {
        let params = {
          pageSize: 1000,
          currentPage: 1,
        };

        const response = await this.$Axios({
          url: `/mcbw/dictionary_datas/partTypeCode/data`,
          type: "get",
          obj: params,
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    changePage(e) {
      this.pages.currentPage = e;
      this.getTabList();
    },
    pageSizeChange(e) {
      this.pages.pageSize = e;
      this.getTabList();
    },
  },
  mounted() {
    this.getDeviceTypeCodeOption().then((res) => {
      this.deviceTypeCode = res.data.data;
    }); //设备类型
  },
};
</script>

<style lang="less" scoped>
.point-shielding-modal {
  .point-shielding-box {
    padding: 20px 0;
    align-items: start;
    .point-shielding-serch {
    }
    .point-shielding-right {
      .point-shielding-page {
        text-align: right;
        margin-top: 10px;
        color: #d9d9d9;
      }
    }
  }
}
/deep/ .point-shielding-modal {
  .ivu-modal-content {
    background-color: #041936;
    box-shadow: inset 0px 0px 30px 0px rgba(62, 117, 190, 0.5);
    .ivu-modal-header {
      border-bottom: 1px solid #979797;
      .ivu-modal-header-inner {
        color: #eef2f4;
      }
    }
    .ivu-form-item-label {
      color: #74d9ff;
    }
    .ivu-input,
    .ivu-select-selection {
      background: rgba(255, 255, 255, 0.2);
      box-sizing: border-box;
      border: 1px solid #596c87;
      color: #74d9ff;
    }
    .ivu-btn-primary {
      background-color: #1677ff;
    }
    .ivu-table th {
      background-color: #104896;
      border-right: 1px solid rgba(255, 255, 255, 0.2);
    }
    .ivu-table td {
      background-color: #041936;
    }
    .ivu-table {
      color: #74d9ff;
    }
    .ivu-table-border td,
    .ivu-table-border th {
      border-right: 1px solid rgba(255, 255, 255, 0.2);
    }
    .ivu-checkbox .ivu-checkbox-inner {
      background-color: rgba(231, 231, 231, 0.5);
    }
    .ivu-table td,
    .ivu-table th,
    .ivu-table-wrapper-with-border {
      border-color: rgba(216, 216, 216, 0.2);
    }
    .ivu-checkbox.ivu-checkbox-checked .ivu-checkbox-inner {
      background-color: #0268fd;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner:after {
      border-color: rgba(255, 255, 255, 0.2);
    }
    .ivu-table-border:after,
    .ivu-table:before {
      background-color: rgba(216, 216, 216, 0.2);
    }
    .ivu-page-next,
    .ivu-page-prev,
    .ivu-page-item,
    .ivu-page-options-elevator input {
      background-color: rgba(255, 255, 255, 0.2);
      border-color: #74d9ff;
      color: #fff;
    }
    .ivu-page-item a {
      color: #d9d9d9;
    }
    .ivu-page-item-active:hover a,
    .ivu-page-item-active a {
      color: #74d9ff;
    }
  }
  .ivu-modal-body {
    padding-top: 15px;
    .show-table-header {
      border-left: 2px solid #02e7e7;
      margin-left: 15px;
      padding-left: 10px;
      .table-header-desc {
        font-size: 18px;
        color: #02e7e7;
      }
      /deep/ .close-btn {
        float: right;
        margin-right: 20px;
        border: 1px solid #08f4f7;
        color: #08f4f7;
        width: 56px;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        outline: none;
        border-color: rgba(8, 244, 247, 0.3);
        background-color: hsla(0, 0%, 100%, 0.1);
      }
    }
  }
  .ivu-modal-footer {
    border-color: #979797;
  }
}
/deep/.ivu-modal-content {
  background-color: #041936;
  box-shadow: inset 0px 0px 30px 0px rgba(62, 117, 190, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/remote-control/point-shielding.vue